import {
  adaptV4Theme,
  createTheme as createMuiTheme,
} from "@mui/material/styles";
import { createVariant } from "./variants";

import createTypography from "./typography";
import overrides from "./overrides";
import breakpoints from "./breakpoints";
import props from "./props";
import shadows from "./shadows";

export const createTheme = (primaryColor, isDarkMode) => {
  const variant = createVariant(primaryColor, isDarkMode);
  const typography = createTypography(primaryColor);

  return createMuiTheme(
    adaptV4Theme(
      {
        spacing: 4,
        breakpoints: breakpoints,
        overrides: overrides,
        props: props,
        typography: typography,
        shadows: shadows,
        header: variant.header,
        sidebar: variant.sidebar,
        palette: variant.palette,
        body: {
          background: "#fff",
        },
      },
      variant.name
    )
  );
};
